import To from 'await-to-js'
import qs from 'qs'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ThreeDimensionsService {
  static async getPipeLineList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/three-dimensions/get-pipe-line-list-async', payload)
    )
    return Callback(err, res)
  }
  static async getMediumMaps(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/three-dimensions/get-medium-maps-async?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async updateMedium(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/three-dimensions/medium-addorupdate', payload)
    )
    return Callback(err, res)
  }
  static async getPipelineMatchList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/three-dimensions/get-pipeline-match-list', payload)
    )
    return Callback(err, res)
  }
  static async updateValveSettings(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/three-dimensions/valvesetting-addorupdate', payload)
    )
    return Callback(err, res)
  }
  static async getValveSettings(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/three-dimensions/get-valvesetting-async?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getValveList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/three-dimensions/get-valvelist-async?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
